import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_CONFIGURABLE_TABLE_PAGE } from './configurableTablePageBreadcrumb.query';

export const ConfigurableTablePageBreadcrumb = () => {
  const { translateBackendString } = useLocalization();
  const { t } = useTranslation('navMenu');
  const { configurableTablePageId } = useParams<{
    configurableTablePageId: string;
  }>();

  const { data } = useQuery(FETCH_CONFIGURABLE_TABLE_PAGE, {
    variables: { configurableTablePageId: configurableTablePageId! },
    skip: !configurableTablePageId,
  });

  return data
    ? translateBackendString(
        data.fetchConfigurableTablePage?.configurableTablePage.name,
      )
    : t('menu.configurableTablePage');
};
